// extracted by mini-css-extract-plugin
export default {"subtitle":"HomeDetailsPage_subtitle__2YIoG","title":"HomeDetailsPage_title__xdVAj","actions":"HomeDetailsPage_actions__hfFqU"};